import { Navigate } from "react-router";
import { usePermissions } from "../context/PermissionContext";
import { getDefaultHomePath } from "../lib/default-home-path";
import LoadingSpinner from "../components/LoadingSpinner";
import AccessDenied from "../components/AccessDenied";

const HomeRedirect = () => {
  const { permissions, loading } = usePermissions();

  if (loading) {
    return <LoadingSpinner />;
  }

  const homePath = getDefaultHomePath(permissions);

  if (!homePath) {
    return (
      <AccessDenied
        title="No Accessible Pages"
        subTitle="You don't have permission to access any section. Contact your administrator."
        redirectPath="/login"
        redirectText="Back to Login"
      />
    );
  }

  return <Navigate to={homePath} replace />;
};

export default HomeRedirect;
